import React from 'react';
import {
  Row,
  Label,
  Col,
  Button,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText
} from 'reactstrap';
import './frascos.styles.css';
import * as acessos from '../../../../../../acessos.const.util';
import IntlMessage from "../../../../../../helpers/intlMessage";

const FrascosPage = props => (
  <Col
    style={{
      height: `${props.altura - 70}px`,
      overflowY: 'scroll',
      overflowX: 'hidden'
    }}
    className='mv-autotexto-container espacamento-container-lateral'
  >
    <Row>
      <Col
        style={{ marginTop: '20px', margin: '10px 32px' }}
        onClick={props.onClickAll}
      >
        <i
          style={{ cursor: 'pointer', marginRight: '10px' }}
          className={props.all ? 'far fa-check-square' : 'far fa-square'}
        />
        <Label className='checkbox-all' check>
          <IntlMessage id = "general.requestsPanel.selectAll"/>
        </Label>
      </Col>
    </Row>
    <ListGroup>
      {props.frascos !== undefined &&
        props.frascos.map((item, i) => (
          <ListGroupItem key={i}>
            <ListGroupItemHeading>
              <i className='fas fa-vial'></i> {item.frasco}
            </ListGroupItemHeading>
            {props.existeBloco &&
              item.blocos.map((bloco, ii) => (
                <ListGroupItemText
                  key={`${i}_${ii}`}
                  className='mv-lista-blocos-macro-editor'
                  onClick={() => props.onClick(bloco)}
                >
                  <span className='checkbox'>
                    <i
                      className={
                        props.blocosSelecionados.indexOf(bloco) === -1
                          ? 'far fa-square'
                          : 'far fa-check-square'
                      }
                    ></i>
                  </span>
                  <span>
                    <span className='frasco-linkToCassete-span'></span>
                    <i className='fas fa-cube'></i> {bloco}
                  </span>
                </ListGroupItemText>
              ))}
          </ListGroupItem>
        ))}
    </ListGroup>
    {props.existeBloco &&
      props.acessoPermitido(props.usuario, acessos.ListaFrasco) &&
      props.acessoPermitido(props.usuario, acessos.Adicionar) && (
        <Button
          color='primary'
          className='mv-inserir-button'
          onClick={props.obterFrascos}
        >
          <IntlMessage id = "dashboards.examDetail.insertMapReport"/>
        </Button>
      )}
  </Col>
);

export default FrascosPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/tabs/frascos/frascos.page.js